import "./Loader.scss";

const Loader = () => (
  <div className="loader-wrapper">
    <div className="loader"></div>
  </div>
);

export default Loader;
